"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _arkReact = require("@dateam/ark-react");
var _Spinner2 = _interopRequireDefault(require("./Spinner"));
var _Spinner;
const Loader = _ref => {
  let {
    className,
    text
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _arkReact.concatClassName)('loader', className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "loader-content"
  }, _Spinner || (_Spinner = /*#__PURE__*/_react.default.createElement(_Spinner2.default, null)), /*#__PURE__*/_react.default.createElement("span", {
    className: "loader-text"
  }, text)));
};
process.env.NODE_ENV !== "production" ? Loader.propTypes = {
  className: _propTypes.default.string,
  text: _propTypes.default.string
} : void 0;
Loader.defaultProps = {
  className: undefined,
  text: undefined
};
var _default = exports.default = Loader;